import DrawRequestPage from "./pages/DrawRequestPage";
import "./styles/drawRequest.scss";

const DrawRequest = () => {
  return <DrawRequestPage />;
};

export default DrawRequest;
